var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menus-item",class:{ 'menus-item-mobile': _vm.isMobile }},[_c('div',{staticClass:"name",on:{"click":function($event){return _vm.handleMenu(_vm.item)}}},[_vm._v(_vm._s(_vm.item.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }